import { render, staticRenderFns } from "./EducationCostBearerInvoicePreview.vue?vue&type=template&id=4db63ad8&scoped=true&"
import script from "./EducationCostBearerInvoicePreview.vue?vue&type=script&lang=ts&"
export * from "./EducationCostBearerInvoicePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db63ad8",
  null
  
)

export default component.exports